import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'spaq-register-contract-page',
  template: `
    <p>
      À venir
    </p>

    <button kendoButton="" [primary]="false" routerLink="/auth/login/email">Retour</button>
  `,
  styles: [],
})
export class RegisterContractPageComponent implements OnInit {

  constructor() {
  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /home/epoirier/PhpstormProjects/spaq-mobile/src/app/auth/register/containers/register-contract-page.component.ts